import { render, staticRenderFns } from "./NoteList.vue?vue&type=template&id=157f47a6"
import script from "./NoteList.vue?vue&type=script&lang=js"
export * from "./NoteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports